// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"82410ae5","14":"cc069684","301":"dbd71233","473":"c81f03e0","752":"66024364","923":"d3b38517","964":"45dd4c5f","968":"34bacfde"}[chunkId] + ".chunk.js";
};